import './index.scss';
import {ResultHeader} from "../ResultsHeader";
import {ResultsPage} from "../ResultsPage";
import React, {useContext, useState} from "react";
import {GlobalContext} from "../../context";
import useStateWithCallback from 'use-state-with-callback';
import {ResultsMenu} from "../ResultsMenu";

export function ResultsComponent({isTabletOrMobile}) {
    const {
        responseArray,
        pages,
        handleUpdateResponses,
        goToContactForm,
        resultOverviewExpandedMobile,
        expandResultOverviewMobile,
        showWishlist,
    } = useContext(GlobalContext);
    const [selectMenu, setSelectMenu] = useState(showWishlist ? 'wishlist' : 'results');
    const [collapsed, setCollapsed] = useStateWithCallback(true, (collapsed) => {
        // correct scrollheight by 300px bc of serverside resize
        setTimeout(function () {
            console.log("original height", document.getElementById("maincontainer").clientHeight, document.getElementById("maincontainer").scrollHeight, collapsed);
            let height = document.getElementById("maincontainer").clientHeight - 300;
            window.parent.postMessage({type: "iframe", message: "resize", height: height}, '*');
        }, 250);
    });

    // set questions as state so we can change them later
    // const [questions, setQuestions] = useState(pages);
    // set current responses as state so we can change them later
    // const [filteredResponseArray, setFilteredResponseArray] = useState(responseArray);

    return (
        <div className={`results${collapsed ? ' collapsed' : ''}`}>
            <ResultHeader
                responses={responseArray}
                questionsArray={pages}
                isTabletOrMobile={isTabletOrMobile}
                handleUpdateResponses={(responses) => {
                    handleUpdateResponses(responses);
                }}
                openOnMobile={(state) => {
                    expandResultOverviewMobile(state);
                    window.scrollTo(0, 0);
                }}
                selectMenu={selectMenu}
                setSelectMenu={setSelectMenu}
                collapsed={collapsed}
                setCollapsed={setCollapsed}
            />
            <div className={`results-page-container d-flex ${isTabletOrMobile ? 'flex-column' : 'flex-row'}`}>
                <ResultsMenu
                    isTabletOrMobile={isTabletOrMobile}
                    collapsed={collapsed}
                />
                {isTabletOrMobile && !resultOverviewExpandedMobile &&
                    <ResultsPage
                        isTabletOrMobile={isTabletOrMobile}
                        goToContactForm={(productInfo) => goToContactForm(productInfo)}
                        responses={responseArray}
                        selectMenu={selectMenu}
                    />
                }
                {!isTabletOrMobile && (
                    <ResultsPage
                        isTabletOrMobile={isTabletOrMobile}
                        goToContactForm={(productInfo) => goToContactForm(productInfo)}
                        responses={responseArray}
                        selectMenu={selectMenu}
                    />
                )}
            </div>
        </div>
    );
}